import React, { useState } from 'react';

import { block } from 'bem-cn';

import './checkbox-marker.scss';

const b = block('checkbox-marker');

type CheckboxMarkerType = {
  isChecked?: boolean;
  onToggle: (selected: boolean) => void;
};

const CheckboxMarker = ({ isChecked = true, onToggle }: CheckboxMarkerType) => {
  const [checked, setChecked] = useState(!!isChecked);

  const toggleHandler = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    event.stopPropagation();
    setChecked(!checked);
    onToggle(!checked);
  };

  return checked ? (
    <div className={b('checked')} onClick={toggleHandler} />
  ) : (
    <div className={b('unchecked')} onClick={toggleHandler} />
  );
};

export default CheckboxMarker;
